import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/fip-logo.png")